import topic from '../topic'
const pathRewrite = '/api'
export const systemAPI = {
    getVersion: pathRewrite + '/get_version',
}